import moment from "moment";

import { BoxAccidentContractDTOBase, BoxAccidentPersonBase } from "../boxAccident.factory";

export class ShortTermAccidentContractDTO extends BoxAccidentContractDTOBase {
    constructor(prototype) {
        super(prototype);
        this.InsuranceProductId = 20;
    }
}

export class ShortTermAccidentInsuredPerson extends BoxAccidentPersonBase {
    constructor() {
        super();
        this.InsuredPersonBirthday = moment().subtract(30, "years").format("YYYY-MM-DD");
    }
}
